import { Grid } from '@material-ui/core';
import React from 'react';
import Card from '../../components/Card/Card.component';
import { IBarPOC } from '../../models/IBars';
import Label from '../Label/Label.component';

interface Props {
    data: IBarPOC
}

export default function BarPOCInfo({
    data
}: Props) {
    return (
        <Card>
            <Grid container>
                <Grid xs={12} md={3} lg={2} item>
                    <Label bold>
                        Name:
                    </Label>
                </Grid>
                <Grid xs={12} md={9} lg={10} item>
                    <Label>
                        {data?.name}
                    </Label>
                </Grid>
                <Grid xs={12} md={3} lg={2} item>
                    <Label bold>
                        Phone:
                    </Label>
                </Grid>
                <Grid xs={12} md={9} lg={10} item>
                    <Label>
                        {data?.phone}
                    </Label>
                </Grid>
                <Grid xs={12} md={3} lg={2} item>
                    <Label bold>
                        Email:
                    </Label>
                </Grid>
                <Grid xs={12} md={9} lg={10} item>
                    <Label>
                        {data?.email}
                    </Label>
                </Grid>
                <Grid xs={12} md={3} lg={2} item>
                    <Label bold>
                        Address:
                    </Label>
                </Grid>
                <Grid xs={12} md={9} lg={10} item>
                    <Label>
                        {data?.address}
                    </Label>
                </Grid>
                <Grid xs={12} md={3} lg={2} item>
                    <Label bold>
                        Role:
                    </Label>
                </Grid>
                <Grid xs={12} md={9} lg={10} item>
                    <Label>
                        {data?.role}
                    </Label>
                </Grid>
            </Grid>
        </Card>
    )
}
